import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {NewSimulationService} from './new-simulation.service';
import {MatDialog, MatDialogRef} from '@angular/material';


@Component({
    selector: 'app-new-simulation',
    templateUrl: './new-simulation.component.html',
    styleUrls: ['./new-simulation.component.css'],
    providers: [NewSimulationService]
})
export class NewSimulationComponent implements OnInit {

    private currentRoute = '';
    public sections;
    closeResult: string;

    constructor(private router: Router, private service: NewSimulationService, public dialog: MatDialog) {

        this.sections = service.sections;

        const that = this;

        this.router.events.subscribe((event) => {
            if (event['urlAfterRedirects']) {
                that.currentRoute = event['urlAfterRedirects'];
            } else {
                that.currentRoute = event['url'];
            }

            for (const section of that.sections) {
                section.active = false;
            }

            const activeRoute = that.sections.find((x) => {
                if (typeof that.currentRoute === 'string') {
                    return that.currentRoute.indexOf(x.id) > -1;
                } else {
                    return false;
                }
            });

            if (activeRoute) {
                activeRoute.active = true;
            }

        });

    }

    ngOnInit() {
    }

    isRoute(route: string): boolean {
        return this.currentRoute.indexOf(route) > -1;
    }

    saveAsDraft() {

        const that = this;

        // this.service.prepareData(this.sections);

        this.service.saveSimulation(this.sections).subscribe((result) => {
            that.openSaveDialog();
        }, (error) => {
            console.log(error);
        });
    }


    public openSaveDialog() {

        const that = this;
        const dialogRef = this.dialog.open(SimulationSavedComponent);
        dialogRef.afterClosed().subscribe(result => {
            that.router.navigate(['/simulation-list']);
        });
    }


}


@Component({
    selector: 'simulation-saved-dialog',
    templateUrl: './simulation-saved.dialog.html',
    styles: [`
        .modal-title {
            text-align: center
        }

        .modal-footer {
            text-align: center;
        }
    `]
})
export class SimulationSavedComponent {

    constructor(public dialogRef: MatDialogRef<SimulationSavedComponent>) {

    }

    public closeDialog() {
        this.dialogRef.close();
    }

}


// WEBPACK FOOTER //
// /home/sboda/Documents/eIRP/MEA_source_code/src/app/components/new-simulation/new-simulation.component.ts